var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._b({attrs:{"chips":"","outlined":"","return-object":"","hide-details":""},model:{value:(_vm.relations),callback:function ($$v) {_vm.relations=$$v},expression:"relations"}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }